import ZapierIntegration from './ZapierIntegration';
export default ZapierIntegration;
